export default __webpack_public_path__ + "static/media/save_screen.edc53fca.jpg";